/** The backend's WORKFLOW_FILE_MAX_BYTES: QC files and review media, below the library's 25 MiB. */
export const WORKFLOW_FILE_MAX_BYTES = 20 * 1024 * 1024;

export const REVIEW_MEDIA_TYPES = ['image/*', 'video/*'] as const;

export const isReviewMediaType = (mimeType: string | null | undefined) =>
  /^(image|video)\//.test(mimeType ?? '');

export const isTooLarge = (bytes: number | null | undefined) =>
  (bytes ?? 0) > WORKFLOW_FILE_MAX_BYTES;
